import React, { useState, useEffect, useRef } from 'react'
import './ConsoleNavMenu.css';
import './SettingsHeader.css';


function SettingsHeader() {

    function goHome(user){
        window.location = "/";
    }

    return(
        <header>
            <div className='console-nav-menu'>
                <div className='empty-grid'>
                    <div className='tel-box logo-box logo-hov' onClick={() => goHome()}>Air-link Console</div>
                    <div className='tel-box menu-box'>
                        <div className='menu-box-sep'/>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default SettingsHeader;